// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import {
  FETCH_DEVICES,
  FETCH_HOSTS,
  FETCH_STATE,
  FETCH_SYSTEM,
  FETCH_CLIENT_ACTIVITY,
  SET_REFRESH_DATE
} from '../actions/multiDRM'

const initialState = {
  devices: null,
  date: null,
  hosts: null,
  state: null,
  system: null,
  activity: null
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_DEVICES:
      return {...state, devices: action.payload.devices}
    case FETCH_HOSTS:
      return {...state, hosts: action.payload.hosts}
    case FETCH_STATE:
      return {...state, state: action.payload.state}
    case FETCH_SYSTEM:
      return {...state, system: action.payload.system}
    case FETCH_CLIENT_ACTIVITY:
      return {...state, activity: action.payload.activity}
    case SET_REFRESH_DATE:
      return {...state, date: action.payload}
    default:
      return state
  }
}
